import {handleActions} from 'redux-actions'
import * as ActionTypes from './actionTypes'

const initialState = {
    lastEditedUserRate: null,
    errors: {},
    updating: false,
}

export default handleActions({
    [ActionTypes.LAST_EDITED_USER_RATE_SET]: (state, {payload: lastEditedUserRate}) => ({...state, lastEditedUserRate}),
    [ActionTypes.ERRORS_SET]: (state, {payload: errors}) => ({...state, errors}),
    [ActionTypes.ERRORS_CLEAR]: (state) => ({...state, errors: {}}),
    [ActionTypes.UPDATING_SET]: (state, {payload: updating}) => ({...state, updating}),
}, initialState)


// WEBPACK FOOTER //
// ./web/js/panels/user/accountSettings/userRates/reducer.js